/* const initSearchBar = () => {
  const searchBtn = document.querySelector('.search-menu-item');
  const searchBtnMobile = document.querySelector('.search-menu-item-mobile');
  const searchFormWrapper = document.querySelector('.ks-search-form-wrapper');
  searchBtn.addEventListener('click',function(){
    this.classList.toggle('form-show');
    searchFormWrapper.classList.toggle('showed');
  });
  searchBtnMobile.addEventListener('click',function(){
    this.classList.toggle('form-show');
    searchFormWrapper.classList.toggle('showed');
  });

  window.addEventListener('resize', () => {
    searchBtn.classList.remove('form-show');
    searchBtnMobile.classList.remove('form-show');
    searchFormWrapper.classList.remove('showed');
  });
}
*/
import { Modal } from 'bootstrap';


const initSearchBar = () => {
  const searchBtn = document.querySelector('.search-menu-item');
  const searchBtnMobile = document.querySelector('.search-menu-item-mobile');


    const modal = new Modal(document.getElementById('googleSearchModal'));

    // Event-Listener für den Button
  searchBtn.addEventListener('click', function() {
      modal.show();  // Modal anzeigen
    });
  searchBtnMobile.addEventListener('click', function() {
      modal.show();  // Modal anzeigen
    });

}
export default initSearchBar;
